import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import LoansPage from './pages/LoansPage';
import RetailersPage from './pages/RetailersPage';
import LoanTypesPage from './pages/LoanTypesPage';
import AgentsPage from './pages/AgentsPage';
import CollectionsPage from './pages/CollectionsPage';
import CollectionHistoryPage from './pages/CollectionHistoryPage';
import ReportsPage from './pages/ReportsPage';
import AgentCollectionSummary from './pages/AgentCollectionSummary';
import RetailerDetailsPage from './pages/RetailerDetailsPage';
import PublicKycUploadPage from './pages/PublicKycUploadPage';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/loans"
            element={
              <PrivateRoute>
                <Layout>
                  <LoansPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/loan-types"
            element={
              <PrivateRoute>
                <Layout>
                  <LoanTypesPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/retailers"
            element={
              <PrivateRoute>
                <Layout>
                  <RetailersPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/agents"
            element={
              <PrivateRoute>
                <Layout>
                  <AgentsPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/collections"
            element={
              <PrivateRoute>
                <Layout>
                  <CollectionsPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/collection-history"
            element={
              <PrivateRoute>
                <Layout>
                  <CollectionHistoryPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Layout>
                  <ReportsPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/agent-collection-summary"
            element={
              <PrivateRoute>
                <Layout>
                  <AgentCollectionSummary />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/retailer-details"
            element={
              <PrivateRoute>
                <Layout>
                  <RetailerDetailsPage />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Public KYC Upload Route (no auth required) */}
          <Route
            path="/kyc-upload/:token"
            element={<PublicKycUploadPage />}
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          <Route
            path="*"
            element={<Navigate to="/dashboard" replace />}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
